// extracted by mini-css-extract-plugin
export default {"section":"Du-z","sectionTitle":"Eu-z","fieldWrapper":"Fu-z","formField":"Gu-z","disabled":"Hu-z","formLabel":"Iu-z"};